import { Utils } from '@/composables/utils';
import { routes } from './routes';
import store from '@/store';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = Utils.getSessionStorage('token');
  // const token = store.getters['authority/token']

  if (to.path != '/login' && !token) {
    router.replace('/login');
  } else {
    next();
  }
});

export default router;
